<section class="new_startup_banner_area">

    <div class="container-fluid">

        <div class="row mt-2">

            <div class="col-lg-6 mt-2 wow fadeInLeft" data-wow-delay="0.4s">
                <div class="new_startup_img">
                    <div class="line line_one" data-aos="fade-down" data-aos-duration="3000">
                        <img src="/assets/projects-images/line_01.png" alt="" loading="lazy" class="img-fluid">
                    </div>
                    <div class="line line_two">
                        <img src="/assets/projects-images/line_02.png" alt="" loading="lazy" class="img-fluid">
                    </div>
                    <div class="line line_three" data-aos="fade-up" data-aos-duration="3000">
                        <img src="/assets/projects-images/line_03.png" alt="" loading="lazy" class="img-fluid">
                    </div>
                    <img src="/assets/projects-images/projectsMainImage.webp" alt="Reno Softwares Projects page main image illustration" loading="lazy" class="img-fluid"
                        data-aos="flip-left" data-aos-duration="3000">
                </div>
            </div>

            <div class="col-lg-6 d-flex align-items-center">
                <div class="new_startup_content" data-aos="flip-up" data-aos-duration="3000">
                    <h2 class="f_700 f_size_40 l_height50 w_color mb_20 wow fadeInRight" data-wow-delay="0.3s">

                        Crafting the Future: <br><span>Highlighting</span> Our Software Projects
                    </h2>
                    <p class="f_400 w_color  wow fadeInRight" data-wow-delay="0.4s">
                        Welcome to our software projects showcase, where innovation meets implementation and imagination
                        becomes reality. Here, we take you on a journey through a collection of remarkable software
                        projects that have pushed boundaries, solved challenges, and made a lasting impact.
                    </p>
                    <div class="action_btn d-flex align-items-center mt-2 mb-2 wow fadeInLeft" data-wow-delay="0.6s">
                      <a class="renoWebsiteBtn" routerLink="/contact"> Let's Talk </a>
                  </div>
                </div>
            </div>

        </div>

    </div>

</section>

<section class="container ">
    
  <h2 class="f_p f_size_40 l_height50 f_600 t_color3  pt_50 mb-30">
      Explore Our Projects
  </h2>
  <p class="pe-3 pt-2">At Reno Softwares, we are committed to delivering practical solutions that address real-world needs. Our projects, while diverse in scope, share a common goal: enhancing user experiences through reliable and innovative technology.</p>
  
  <div class="separator">
      <span>
          <i class="bi bi-square-fill"></i>
      </span>
  </div>
  
  <!-- Projects -->
  <section>
    <!-- 01 Project with Sub-Projects carousel -->
    <div class="custom-container ">
      <input class="carousel__btn" type="radio" name="carousel-control" id="carousel__btn1" hidden />
      <input class="carousel__btn" type="radio" name="carousel-control" id="carousel__btn2" hidden />
      <input class="carousel__btn" type="radio" name="carousel-control" id="carousel__btn3" hidden />
      <div class="carousel"> 
        <h3 class="text-secondary">01</h3>
        <div class="carousel__slides">
        
            <div class="carousel__slid">
              <div class=" row" >
                  <div class="col-12  col-lg-6 order-3 order-lg-1">
                        
                    <h2 class="carousel__title">GateHouse Solutions</h2>
                    <p class="carousel__paragraph ">
                    The GateHouse Solutions™ security gate software is the leading technology in managing access
                    to gated communities. It is designed to continue to operate even when network connectivity
                    is lost so that residents and visitors are never inconvenienced with long lines and
                    compromised security.
                    </p>
                    <p><b>Offline Operation</b></p>
                    <p><b>Access Management</b></p>
                    <p><b>Enhanced Security</b></p>
                    <p><a class="app_btn mt-3" href="https://www.gatehousesolutions.com/ " title="Site Link" target="_blank">Visit site</a></p>  
                  </div>
                  
                  <div class="col-12  col-lg-6 order-1 order-lg-3 my-auto">
                      <img class="img-fluid " src="/assets/projects-images/gatehouseproject.webp" alt="GateHouse Solutions™ project by Reno Softwares, a security gate software for managing access to gated communities" />
                  </div>
              </div>
            </div>
            <div class="carousel__slid">
              <div class="row" >
                  <div class="col-12  col-lg-6 order-3 order-lg-1">
                        
                    <h2 class="carousel__title">GateHouse Mobile App</h2>
                    <p class="carousel__paragraph ">
                        GateHouse Solutions™ Resident Phone App Module allows residents and administrators to
                        conveniently use their smartphone to manage their resident profile and visitor list.
                    </p>

                    <p><b>Profile Management</b></p>
                    <p><b>Visitor List Control</b></p>
                    <p><b>Notifications</b></p>
                  <p><a class="app_btn mt-3" href="https://play.google.com/store/apps/details?id=com.temsystems.gatehouse&hl=en " title="Site Link" target="_blank">Discover App</a></p>
                  </div>
                  
                  <div class="col-12  col-lg-6 order-1 order-lg-3 my-auto">
                      <img class="img-fluid" src="/assets/projects-images/gatehouseMobile.webp" alt="GateHouse Mobile App project of Reno Softwares, a Resident Phone App feature graphic" />
                  </div>
              </div>
            </div>
            
            <div class="carousel__slid">
              <div class="row" >
                  
                  <div class="col-12  col-lg-6 order-3 order-lg-1">
                        
                    <h2 class="carousel__title">GateHouse Guard App</h2>
                    <p class="carousel__paragraph ">
                            It allows the guard to use a tablet to process visitors, open the gate, and print visitor ID
                            badges to a portable or remote printer, scan visitor passes via barcode scanner.
                    </p>
                    <p><b>Visitor Processing</b></p>
                    <p><b>Gate Control</b></p>
                    <p><b>Barcode Scanning</b></p>
                    <p><a class="app_btn mt-3" href="https://www.gatehousesolutions.com/products" title="Site Link" target="_blank">Learn More</a></p>

                  
                  </div>
                  
                  <div class="col-12  col-lg-6 order-1 order-lg-3 my-auto">
                      <img class="img-fluid" src="/assets/projects-images/gatehouseGaurd.webp" alt="GateHouse Guard App project by Reno Softwares, a Resident security gate software feature graphic" />
                  </div>
              </div>
            </div>
        </div>
        <div class="carousel__control">
          <label for="carousel__btn1" id="carousel__nav1" class="carousel__nav"></label>

          <label for="carousel__btn2" id="carousel__nav2" class="carousel__nav"></label>

          <label for="carousel__btn3" id="carousel__nav3" class="carousel__nav"></label>
        </div>
      </div>
      
    </div>

    <!-- 02 Project -->
    <div class="project__container">
      <h3 class="text-secondary">02</h3>
      <br>
      <div class="row" >
        <div class="col-12  col-lg-6 order-2 order-lg-2">
                
          <h2 class="project__tilte">Flex And Punch</h2>
          <p class="project__paragraph ">
          Flex and Punch is a website designed for a fitness studio, providing essential information about classes, schedules, trainers, and membership options in a user-friendly format.
          </p>
          <p><b>Class Schedules</b> </p>
          <p><b>Trainer Profiles</b> </p>
          <p><b>Membership plans and pricing</b></p>
          <p><a class="app_btn mt-3" href="https://flexandpunch.com/" title="Site Link" target="_blank">Visit site</a></p>

        </div>
        
        <div class="col-12  col-lg-6 order-1 order-lg-1 my-auto">
            <img class="img-fluid" src="/assets/projects-images/flex.webp" alt="FlexAndPunch project by Reno Softwares, a fitness studio Website feature graphic" />
        </div>
      </div>
    </div>

    <!-- 03 Project -->
    <div class="project__container" >
      <h3 class="text-secondary">03</h3>
      <br>
      <div class="row" >
        <div class="col-12  col-lg-6 order-3 order-lg-1">
                
          <h2 class="project__tilte">Flavour Of Kashmir</h2>
          <p class="project__paragraph  ">
          The "Flavour of Kashmir" website showcases the culinary offerings of Kashmir, curated for catering and on-demand delivery services. It features a curated selection of dishes tailored for events and personal orders.
          </p>
          <p><b>Culinary Showcase</b></p>
          <p><b>Service Overview</b></p>
          <p><b>Custom Orders</b></p>
                <p><a class="app_btn mt-3" href="https://flavourofkashmir.com/" title="Site Link" target="_blank">Visit site</a></p>
        </div>
        
        <div class="col-12  col-lg-6 order-1 order-lg-3 my-auto">
            <img class="img-fluid" src="/assets/projects-images/flavourProject.webp" alt="FlavourOfKashmir project by Reno Softwares, a culinary offerings and catering Website feature graphic" />
        </div>
      </div>
    </div>
       <!-- 03 Project -->
       <div class="project__container" >
        <h3 class="text-secondary">04</h3>
        <br>
        <div class="row" >
          <div class="col-12  col-lg-6 order-1 order-lg-1 my-auto">
            <img class="img-fluid" src="/assets/projects-images/mandcorp.webp" alt="FlavourOfKashmir project by Reno Softwares, a culinary offerings and catering Website feature graphic" />
        </div>
          <div class="col-12  col-lg-6 order-3 order-lg-3">
                  
            <h2 class="project__tilte">M&CO</h2>
            <p class="project__paragraph  ">
              The MCO Group website has been developed to highlight it's independent power production, which specializes in owning and operating renewable energy projects. It includes providing insights into their capabilities in engineering, procurement, and construction within the renewable energy sector.
            </p>
            <p><b>Magpie Hydel</b></p>
            <p><b>Mass N-ERGY</b></p>
            <p><b>Hotel Pine Palace</b></p>
                  <p><a class="app_btn mt-3" href="https://mandcorp.com/" title="Site Link" target="_blank">Visit site</a></p>
          </div>
          
        
        </div>
      </div>
  </section>
</section>

